export const OFFER_TYPE={
    DEFAULT:'default_offer',
    OFFER:'offer',
}


export const INVENTORY_ACTION = {
    GIF_LOAD:'gif_load',
    BUTTTON_CLICK:'button_click'
}